<template>
<div class="group-work-panel" v-if="prepareClassInfo.prepareClass">
  <div class="group-work-container">
    <div class="group-title">{{title}}</div>
    <div class="group-before-container" v-if="prepareClassInfo.studentCount === 0">
      <div class="left-line"></div>
      <div class="circle">1
        <div class="circle-info">
          <span>点击页面底部</span>
          <span>购课按钮付款参团</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="circle">2
        <div class="circle-info">
          <span>分享并邀请</span>
          <span>好友支付参团</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="circle">3
        <div class="circle-info">
          <span>达到人数</span>
          <span>拼团成功并开班</span>
        </div>
      </div>
      <div class="right-line"></div>
    </div>
    <div class="group-waiting-container" v-else>
      <div class="notice">还差 <span>{{prepareClassInfo.minCloseNum - prepareClassInfo.studentCount}}</span> 人</div>
      <countdown :times="prepareClassInfo.prepareClassCountDown"></countdown>
      <div class="avator-list">
        <div class="avator" v-for="(num, index) in prepareClassInfo.minCloseNum" :key="num" :class="{'uninvited': index >= prepareClassInfo.studentCount}"></div>
      </div>
      <div class="invite-btn" @click.stop="toInvite">邀请好友拼团</div>
      <div class="sub-info">
        <span class="info">邀请好友参团</span>
        <span class="icon"></span>
        <span class="info">拼成功立即开班</span>
        <span class="icon"></span>
        <span class="info">人数不足立即退款</span>
      </div>
    </div>
  </div>
  <div class="group-work-rules">
    <p>拼团规则</p>
    <span>活动时间：以详情页面展示倒计时为准。</span>
    <span>可参与用户：成功注册学而思·爱智康的用户均可参与拼团。</span>
    <span>拼团规则：</span>
    <span>参与拼团，成功支付后，即可在右下角 我的-我的订单 页面找到拼团订单；</span>
    <span>倒计时结束前，参团人数达到成团标准，即视为拼团成功，直接报入对应班级；</span>
    <span>倒计时结束前，参团人数若未达标，预付参团费用将全额退回学员卡；</span>
  </div>
  <guide v-if="guideShow" @close="toInvite"></guide>
</div>
</template>
<script>
import {mapState} from 'vuex';
import countdown from './_countdown'
import guide from './_guide'
export default {
  components: {
    countdown,
    guide
  },
  computed: {
    title() {
      return this.prepareClassInfo.studentCount === 0 ? '如何参加拼团' : 'TA们正在拼团'
    },
    ...mapState({
      prepareClassInfo: state => state.course.courseBottomInfo
    })
  },
  data() {
    return {
      guideShow: false
    }
  },
  methods: {
    toInvite() {
      this.guideShow = !this.guideShow
    }
  }
}
</script>
<style lang="less" scoped>
.group-work-panel {
  width: 100%;
  padding: 0.4rem 0.3rem;
  border-top: 0.1rem solid #f7f7f7;

  .group-work-container {
    background:rgba(226,73,67,0);
    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.08);
    border-radius: 8px;
    border: 1px solid rgba(240,240,240,1);
    padding: 0 0.45rem 0.4rem;
    .group-title {
      width: 3rem;
      height: 0.62rem;
      text-align: center;
      font-size: 0.3rem;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
      color:rgba(255,255,255,1);
      line-height: 0.62rem;
      background: url('./img/top.png') no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .group-before-container {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.4rem;
      padding-bottom: 0.8rem;
      .left-line {
        width: 0.68rem;
        height: 1px;
        background: url('./img/guide_left.png') no-repeat;
        background-size: 100% 100%;
      }
      .right-line {
        width: 0.68rem;
        height: 1px;
        background: url('./img/guide_right.png') no-repeat;
        background-size: 100% 100%;
      }
      .circle {
        width: 0.44rem;
        height: 0.44rem;
        border-radius: 50%;
        background-color: #E24943;
        margin: 0 0.1rem;
        font-size: 0.28rem;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
        color:rgba(255,255,255,1);
        line-height: 0.44rem;
        text-align: center;
        position: relative;
        .circle-info {
          position: absolute;
          white-space: nowrap;
          top: 0.64rem;
          transform: translateX(-50%);
          margin-left: 0.22rem;
          span {
            font-size: 12px;
            display: block;
            color: #333333;
            line-height: 15px;
            font-family: PingFangSC-Regular,PingFang SC;
            font-weight: 400;
          }
        }
      }
      .line {
        flex: 1;
        background-color: #CCCCCC;
        height: 1px;
      }
    }

    .group-waiting-container {
      .notice {
        margin-top: 0.32rem;
        font-size: 0.32rem;
        line-height: 0.32rem;
        font-family: PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
        color:rgba(51,51,51,1);
        text-align: center;
        margin-bottom: 0.2rem;
        span {
          color: #E24943;
        }
      }
      .avator-list {
        margin-top: 0.32rem;
        width: 100%;
        height: 44px;
        overflow-x: scroll;
        overflow-y: hidden;
        white-space: nowrap;
        text-align: center;
        line-height: 0;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 20px;
        .avator {
          display: inline-block;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin: 0 0.1rem;
          background: url('http://static1.izhikang.com/webresource/usertech-public/wxliteImg/common/head_male.png') no-repeat;
          background-size: 100% 100%;
          &.uninvited {
            background: url('./img/empty_hp.png') no-repeat;
            background-size: 100% 100%;
          }
        }
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
      }
      .invite-btn {
        width: 5.6rem;
        margin: 0.4rem auto 0;
        height: 0.8rem;
        text-align: center;
        line-height: 0.8rem;
        border-radius: 40px;
        background-color: #E24943;
        color: #ffffff;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold,PingFang SC;
        font-weight: 600;
      }
      .sub-info {
        margin-top: 0.28rem;
        text-align: center;
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon {
          display: inline-block;
          width: 0.28rem;
          height: 0.28rem;
          background: url('./img/arrow_small_grey.png') no-repeat;
          background-size: 100% 100%;
        }
        .info {
          font-size: 0.24rem;
          transform: scale(0.94);
        }
      }
    }
  }

  .group-work-rules {
    margin-top: 0.4rem;
    p {
      font-size: 14px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      color:rgba(51,51,51,1);
      line-height: 14px;
      margin-bottom: 0.16rem;
    }
    span {
      display: block;
      font-size: 12px;
      color:rgba(102,102,102,1);
      line-height: 17px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/courseCenter/public/groupWork/grouWork.vue